


























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { WithdrawSettle, Withdraw, Wallet } from "@/interfaces";
import {
  dispatchGetWithdraws,
  dispatchSettleWithdraw,
  dispatchGetWithdrawStates
} from "@/store/main/actions";
import {
  readOneWithdraw,
  readWithdrawStateName,
  readHasAdminAccess
} from "@/store/main/getters";
import { readUserOneWallet, readCurrencyName } from "@/store/wallet/getters";
import { readAdminOneUser } from "@/store/admin/getters";
import {
  dispatchGetWallets,
  dispatchGetCurrencies
} from "@/store/wallet/actions";
import { dispatchGetUsers } from "@/store/admin/actions";

@Component
export default class SettleWithdraw extends Vue {
  public valid = true;
  public loading = true;
  public admin = false;
  public transaction_time: string | null = null;
  public tx_hash: string | null = null;
  public rrn: string | null = null;
  public amount: number | null = null;
  public phi: number | null = null;
  public receipt_format: string | null = null;
  public receipt_image_b64: string | null = null;
  public additional_data: any = null;
  public image_file: File | null = null;

  public withdraw: Withdraw | null = null;
  public wallet: Wallet | null = null;

  public snackbar = false;
  public text_copy = "";


  public TYPE_TRANSFER = 1;
  public TYPE_WITHDRAW = 2;
  public type = this.TYPE_WITHDRAW;

  public async mounted() {
    this.loading = false;
    const promises = [
      dispatchGetWithdraws(this.$store),
      dispatchGetWallets(this.$store),
      dispatchGetWithdrawStates(this.$store),
      dispatchGetCurrencies(this.$store)
    ];
    if (readHasAdminAccess(this.$store)) this.admin = true;
    if (this.admin) {
      promises.push(dispatchGetUsers(this.$store));
    }
    await Promise.allSettled(promises);
    const withdraw = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    );
    if (withdraw) this.withdraw = withdraw;
    const wallet_id = this.withdraw?.to_wallet_id;
    if (wallet_id) {
      const wallet = readUserOneWallet(this.$store)(wallet_id);
      if (wallet) this.wallet = wallet;
      this.type = this.TYPE_WITHDRAW;
    }else{
      this.type = this.TYPE_TRANSFER;
    }
    this.reset();
    this.loading = false;
  }

  public reset() {
    this.$validator.reset();
    if (this.withdraw) {
      if (this.withdraw.reciept) {
        this.tx_hash = this.withdraw.reciept;
        this.rrn = this.withdraw.reciept;
      } else {
        this.tx_hash = null;
        this.rrn = null;
      }
      this.amount = this.withdraw.from_amount;
      if (this.withdraw.transaction_phi)
        this.phi = this.withdraw.transaction_phi;
      else this.phi = null;
      if (this.withdraw.done_datetime)
        this.transaction_time = this.withdraw.done_datetime;
      else this.transaction_time = null;
      if (this.withdraw.reciept_image_b64)
        this.receipt_image_b64 = this.withdraw.reciept_image_b64;
      else this.receipt_image_b64 = null;
      if (this.withdraw.reciept_image_format)
        this.receipt_format = this.withdraw.reciept_image_format;
      else this.receipt_format = null;
      this.additional_data = null;
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async getImage(image_file: File) {
    return new Promise<string | ArrayBuffer | null>(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(image_file);
    });
  }
  public async submit() {
    if (this.image_file) {
      console.log(this.image_file);
      const result = await this.getImage(this.image_file);
      if (typeof result === "string" || result instanceof String) {
        const splited = result.split(",", 2);
        this.receipt_image_b64 = splited[1];
        this.receipt_format = splited[0].split(";")[0].split("/")[1];
        console.log(this.receipt_format);
      }
    }
    if (await this.$validator.validateAll()) {
      const settle: WithdrawSettle = {};
      if (this.tx_hash && this.tx_hash != this.withdraw?.reciept)
        settle.tx_hash = this.tx_hash;
      if (this.rrn && this.rrn != this.withdraw?.reciept) settle.rrn = this.rrn;
      if (
        this.transaction_time &&
        this.transaction_time != this.withdraw?.done_datetime
      )
        settle.transaction_time = this.transaction_time;
      if (this.amount && this.amount != this.withdraw?.from_amount)
        settle.amount = this.amount;
      if (this.phi && this.phi != this.withdraw?.transaction_phi)
        settle.phi = this.phi;
      if (this.receipt_image_b64)
        settle.receipt_image_b64 = this.receipt_image_b64;
      if (this.receipt_format) settle.receipt_format = this.receipt_format;
      if (this.additional_data) settle.additional_data = this.additional_data;
      console.log(settle);
      await dispatchSettleWithdraw(this.$store, {
        id: this.withdraw!.id,
        withdrawSettle: settle
      });
      this.$router.push("/main/withdraws");
    }
  }

  get from_amount() {
    const amount = this.withdraw?.from_amount;

    if (!this.withdraw?.currency) return "----";

    const currency = readCurrencyName(this.$store)(this.withdraw?.currency);

    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)).toLocaleString() + "تومان";
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETH";
    }else if (currency === "ETC") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETC";
    }else if (currency === "ZIL") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "ZIL";
    }else if (currency === "XCH") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "XCH";
    }else if (currency === "XCC") {
      if (amount) return (amount / 10 ** 8).toFixed(5) + "XCC";
    }
    return "----";
  }

  get to_amount() {

    let currency;
    if(this.type == this.TYPE_WITHDRAW){
      if (!this.wallet || !this.wallet?.currency) return "----";
      currency = readCurrencyName(this.$store)(this.wallet?.currency);
    }else {
      if (!this.withdraw?.currency) return "----";
      currency = readCurrencyName(this.$store)(this.withdraw?.currency);
    }

    const amount = this.withdraw?.to_amount;
    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)).toLocaleString() + "تومان";
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETH";
    }else if (currency === "ETC") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETC";
    }else if (currency === "ZIL") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "ZIL";
    }else if (currency === "XCH") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "XCH";
    }else if (currency === "XCC") {
      if (amount) return (amount / 10 ** 8).toFixed(5) + "XCC";
    }
    return "----";
  }

  get to_amountRaw() {
    if (!this.wallet || !this.withdraw?.currency) return "----";

    const currency = readCurrencyName(this.$store)(this.wallet?.currency);

    const amount = this.withdraw?.to_amount;
    console.log(this.currency, amount);
    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)) * 10; // convert to Rials
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5);
    }
    return "----";
  }
  get wallet_string() {
    if (!this.wallet) return "----";
    return `${this.wallet.id}/${this.wallet.owner_id}/${this.wallet.name}/${this.wallet.currency}/${this.wallet.address}`;
  }
  get user() {
    const user_id = this.withdraw?.from_user_id;
    if (user_id) return readAdminOneUser(this.$store)(user_id);
    return null;
  }

  get user_string() {
    if (!this.user) return "----";
    return `${this.user.id}/${this.user.full_name}/${this.user.mobile}/${this.user.balance}`;
  }

  get currency() {

    if (!this.wallet || !this.withdraw?.currency) return "----";
    return `${readCurrencyName(this.$store)(
      this.withdraw?.currency
    )}->${readCurrencyName(this.$store)(this.wallet?.currency)}`;
  }
  get state() {
    const state_id = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    )?.state;
    if (!state_id) return "----";
    return readWithdrawStateName(this.$store)(state_id);
  }

  public getColor() {
    if (this.state === "COMPLETED" || this.state === "MANUAL_SETTLEMENT")
      return "color:green";
    else if (this.state === "REJECTED" || this.state === "FAILED")
      return "color:red";
    return "color:blue";
  }


  public copy2clipboard(text){
      navigator.clipboard.writeText(text);
      this.text_copy= text;
      this.snackbar = true;
  }

}
